module.exports = __webpack_public_path__ + "img/1.d8d8b3e1.webp";